import http from './http'

export function exportCatalogMenu() {
  return http.get('catalog/menu/export').then((res) => res.data)
}

export function importCatalogMenu(payload) {
  if (payload instanceof FormData) {
    return http.post('catalog/menu/import', payload).then((res) => res.data)
  }
  return http.post('catalog/menu/import', payload).then((res) => res.data)
}
